import AsonicCalendarCellPresenter from "./asonic-calendar-cell-presenter";

const AsonicCalendarCellContainer = <P extends object>(props: P) => {
  return <AsonicCalendarCellPresenter {...props} />;
};

export default AsonicCalendarCellContainer;
